module.exports = __webpack_public_path__ + "img/role02.20f434f1.png";